import { render, staticRenderFns } from "./WalletDetailTable.vue?vue&type=template&id=365c88af&scoped=true"
import script from "./WalletDetailTable.vue?vue&type=script&lang=js"
export * from "./WalletDetailTable.vue?vue&type=script&lang=js"
import style0 from "./WalletDetailTable.vue?vue&type=style&index=0&id=365c88af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c88af",
  null
  
)

/* custom blocks */
import block0 from "./WalletDetailTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports